import { Grid, Img } from "@chakra-ui/react";

const SplashScreen = () => {
  return (
    <Grid w="100vw" h="100vh" placeContent="center">
      <Img src="/android-chrome-192x192.png" alt="Dominion Estate" />
    </Grid>
  );
};

export default SplashScreen;
